var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c(_setup.FlexibleWorkMap),_c(_setup.PageTabs,{staticClass:"mt-4",attrs:{"items":_setup.pageItems}}),(_setup.$route.query.view === _setup.SHIFTS_VIEW_TYPE.SCHEDULE)?_c(_setup.FlexibleWorkSchedule):_c(_setup.FlexibleWorkShifts,{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }